import {CmsReactComponent} from 'components/cms/CmsReactComponent';
import {
    EntryOptions,
    PropertyDefinition,
    PropertyMappingType
} from "app/library/layout-builder";
import {PhotoGalleryFullProps} from "./types";
import {MetaTypeEnum} from "app/shared";
import {ImageChildrenDefinitions} from "../definitions";

export class PhotoGalleryFullDefinitions extends CmsReactComponent<PhotoGalleryFullProps> {
    static defaultProps = {};

    static schemaName = "photo-gallery-full";

    static propertyDefinitions: PropertyDefinition[] = [
        {
            name: "data",
            description: "Fotoğraf Galerisi Elemanları",
            mapping: {
                type: PropertyMappingType.ArrayData,
                keys: [

                    {
                        mapping: {
                            type: PropertyMappingType.Image
                        },
                        name: "thumbnail",
                        text: "Görsel Öne Çıkarılmış",
                    },
                    {
                        mapping: {
                            type: PropertyMappingType.Image
                        },
                        name: "src",
                        text: "Görsel Yolu",
                    },
                    {
                        mapping: {
                            type: PropertyMappingType.String
                        },
                        name: "alt",
                        text: "Görsel Alt Etiketi",
                    },
                    {
                        mapping: {
                            type: PropertyMappingType.String
                        },
                        name: "caption",
                        text: "Görsel Başlık",
                    },
                    {
                        mapping: {
                            type: PropertyMappingType.String
                        },
                        name: "subcaption",
                        text: "Görsel Alt Başlık",
                    },
                ]
            }
        },
        {
            name: "thumbnail",
            mapping: {
                type: PropertyMappingType.ParentObject,
                children: ImageChildrenDefinitions,
            },
            description: "Slider Thumbs",
        },
        {
            name: "seeText",
            mapping: {
                type: PropertyMappingType.String,
            },
            description: "Slider Thumbs Full Gör Yazısı",
        },
    ];


    static options: EntryOptions = {
        meta: {
            use: true,
            allowedTypes: [
                MetaTypeEnum.MultiImage,
                MetaTypeEnum.PhotoGallery
            ]
        },
        mappingFields: [
            {
                name: "thumbnail",
                text: "Görsel Öne Çıkarılmış",
                types: [MetaTypeEnum.SingleImage],
            },
            {
                name: "src",
                text: "Görsel Yolu",
                types: [MetaTypeEnum.SingleImage],
            },
            {
                name: "alt",
                text: "Görsel Alt Etiketi",
                types: [MetaTypeEnum.Text, MetaTypeEnum.TextArea],
            },
            {
                name: "caption",
                text: "Görsel Başlık",
                types: [MetaTypeEnum.Text, MetaTypeEnum.TextArea],
            },
            {
                name: "subcaption",
                text: "Görsel Alt Başlık",
                types: [MetaTypeEnum.TextArea, MetaTypeEnum.Text, MetaTypeEnum.Editor]
            }

        ]
    };
}
